import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'

export const CatchupProgramCardSC = styled.div`
  padding: var(${FIXED_INDENTS.INDENT_40});
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`
